import { formatPhoneDisplay } from '@/lib/contacts/phone';
import { normalizePhoneForTel } from '@/lib/visits/format';

export interface OfficeContact {
  kind: 'phone' | 'email';
  href: string;
  /** What the link shows: the formatted number, or the address. */
  value: string;
}

/**
 * How a customer reaches the business from the portal: the company phone and
 * email its invoices print, phone first. Empty when the company set neither.
 */
export function officeContacts(
  tenant: { phone?: string | null; email?: string | null } | undefined,
): OfficeContact[] {
  const contacts: OfficeContact[] = [];
  const phone = tenant?.phone?.trim();
  if (phone) {
    contacts.push({
      kind: 'phone',
      href: `tel:${normalizePhoneForTel(phone)}`,
      value: formatPhoneDisplay(phone),
    });
  }
  const email = tenant?.email?.trim();
  if (email) {
    contacts.push({ kind: 'email', href: `mailto:${email}`, value: email });
  }
  return contacts;
}
